/**
 * Enum representing model codes used for identifying specific model values and attributes.
 */
export enum EnumModelCodes {
  /**
   * The full name for the percentile (e.g., "Percentile").
   */
  PercentileFullName = 'perc-name',

  /**
   * The name for the low percentile (e.g., "Percentile Low").
   */
  PercentileLowName = 'perc-name-low',

  /**
   * The name for the target percentile (e.g., "Percentile Target").
   */
  PercentileTargetName = 'perc-name-target',

  /**
   * The name for the high percentile (e.g., "Percentile High").
   */
  PercentileHighName = 'perc-name-high',

  /**
   * The deal calculated volume discount adjustment 
   */
  DealVolumeAdjustment = "deal-vol-adj",

  /**
   * The symbol for the currency (e.g., "$").
   */
  CurrencySymbol = "curr-symbol",

  /**
   * The short code for the currency (e.g., "USD").
   */
  CurrencyCode = "curr-short",

  /**
   * The code for the country.
   */
  Country = "ctry",

  /**
   * The duration of the deal in months
   */
  DealLength = "deal-months",

  /**
   * Deal Id
   */
  DealId = "did",

  /**
 * Company client name
 */
  CompanyName = "cli-name",


  /**
   * Auto retrieval of time segments that are in scope for the deal
   */
  TimeSegment = 'time-segment',

  /**
   * VarName code for deal status scenario lookup
   */
  DealStatusScenario = 'dl-status-scen',

  /**
   * VarName code for when the deal was last calculated on
   */
  LastCalculatedOn = 'calc-on',

  /**
   * Code for the date a deal/deal item was created - set once and must never change afterward.
   */
  DateCreated = 'datecreated',

  /**
   * code for expected spend in Non IT services
   */
  ExpectedSpend = 'expected-spend',

  /**
   * code for use custom adjustments
   */
  UseCustomAdjustment = 'use-cust-adjust'

}


